import { makeStyles } from "@mui/styles";
import "react-toastify/dist/ReactToastify.min.css";

const notificationStyle = {
  display: "flex",
  alignItems: "center",
  boxShadow: "none",
  overflow: "visible",
};

export default makeStyles((theme) => {
  const contextClass = {
    success: theme.palette.NOTIFICATION_COLORS.success,
    info: theme.palette.NOTIFICATION_COLORS.info,
    warning: theme.palette.NOTIFICATION_COLORS.warning,
    danger: theme.palette.NOTIFICATION_COLORS.danger,
    error: theme.palette.NOTIFICATION_COLORS.danger,
  };

  return {
    notificationContainer: {
      display: "flex",
      alignItems: "flex-start",
    },
    notificationContained: {
      borderRadius: 5,
      transition: "max-height 0.3s ease-out",
      minHeight: 38,
      maxHeight: 100,
    },
    expanded: {
      maxHeight: 750,
    },
    notificationContainedShadowless: {
      boxShadow: "none",
    },
    notificationIconContainer: {
      minWidth: 45,
      maxWidth: 200,
      borderRadius: 45,
      display: "flex",
      justifyContent: "center",
      fontSize: 24,
    },
    notificationIconContainerRounded: {
      marginRight: theme.spacing(2),
    },
    containedTypography: {
      color: "white",
    },
    messageContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexGrow: 1,
      wordBreak: "break-word",
      marginTop: 3,
    },
    extraButton: {
      color: "white",
      "&:hover, &:focus": {
        background: "blue",
      },
    },
    notificationSuccess: {
      ...notificationStyle,
      color: `${theme.palette.NOTIFICATION_COLORS.success} !important`,
      background: `${theme.palette.background.success} !important`,
    },
    notificationDanger: {
      ...notificationStyle,
      color: `${theme.palette.NOTIFICATION_COLORS.danger} !important`,
      background: `${theme.palette.background.danger} !important`,
    },
    notificationInfo: {
      ...notificationStyle,
      color: `${theme.palette.NOTIFICATION_COLORS.info} !important`,
      background: `${theme.palette.background.info} !important`,
    },
    notificationWarning: {
      ...notificationStyle,
      color: `${theme.palette.NOTIFICATION_COLORS.warning} !important`,
      background: `${theme.palette.background.warning} !important`,
    },
    notificationComponent: {
      paddingRight: theme.spacing(4),
    },
    toastsContainer: {
      marginTop: theme.spacing(6),
      right: 0,
      width: "auto",
    },
    notificationCloseButton: {
      position: "absolute",
      right: theme.spacing(2.5),
      top: theme.spacing(2),
    },
    seeMore: {
      cursor: "pointer",
      textDecoration: "underline",
    },
    progress: {
      visibility: "hidden",
    },
    bodyClassName: {
      overflowY: "auto",
    },
    popper: {
      zIndex: 15000,
    },
    toastClassName: ({ type }) =>
      contextClass[type || "default"] +
      " flex p-1 min-h-10 rounded-md justify-between overflow-hidden cursor-pointer",
  };
});
